// Pure builder for the '.event' menu, mirroring js/calendar.v2.8.js:842-939 exactly, including the
// safeguard (null = no menu at all) for when nothing is actionable.

import { colorAction, copyAction, cutAction, deleteAction, feedbackAction, notificationAction, USER_COLOR_PALETTE } from './actions';
import { t } from './legacy';
import { MenuEntry } from './menu';

export function buildEventMenu(eventEl: HTMLElement): MenuEntry[] | null {
  const isModifable = eventEl.classList.contains('modifable');
  const hasCustomMode = eventEl.dataset.hasCustomMode === '1';
  const hasFeedback = eventEl.classList.contains('feedback');
  const items: MenuEntry[] = [];

  if (isModifable) {
    items.push(
      { label: t('js.ctx_copy_event', 'Copy event'), icon: 'copy', run: copyAction(eventEl) },
      { label: t('js.ctx_cut_event', 'Cut event'), icon: 'copy', run: cutAction(eventEl) },
      { label: t('js.ctx_delete_event', 'Delete event'), icon: 'delete', run: deleteAction(eventEl) },
    );
  }

  if (hasCustomMode) {
    if (isModifable) items.push({ separator: true });
    for (const entry of USER_COLOR_PALETTE) {
      items.push({ label: t(entry.i18nKey, entry.fallback), icon: 'edit', run: colorAction(eventEl, entry.hex) });
    }
    items.push({ label: t('js.color_none', 'No color'), run: colorAction(eventEl, '') });
  }

  if (isModifable || hasFeedback) {
    items.push({ separator: true }, { label: t('js.ctx_feedback', 'Feedback'), run: feedbackAction(eventEl) });
  }

  if (eventEl.getAttribute('data-href')) {
    items.push({ separator: true }, { label: t('js.ctx_email_notification', 'Email notification'), icon: 'edit', run: notificationAction(eventEl) });
  }

  const actionCount = items.filter((entry) => !('separator' in entry)).length;
  if (actionCount === 0) return null;

  items.push({ separator: true }, { label: t('js.ctx_quit', 'Close'), icon: 'quit', run: () => undefined });
  return items;
}
